export default [
    {
        path: "/",
        name: "HomeIndex",
        component: () => import("@/views/index.vue"),
        redirect: '/homePage',
        children: [
            {
                path: "homePage",
                name: "HomePage",
                component: () => import("@/views/SIBI/homePage/index.vue"),
                meta: {
                    type: 'tabbar',
                    title: '首页',
                    url: require('@/assets/image/SIBI/tabbar/icon_tab_sy_c.png'),
                    activeUrl: require('@/assets/image/SIBI/tabbar/icon_tab_sy_o.png')
                }
            },
            {
                path: "bondPage",
                name: "bondPage",
                component: () => import("@/views/SIBI/bondPage/index.vue"),
                meta: {
                    type: 'tabbar',
                    title: '申购',
                    url: require('@/assets/image/SIBI/tabbar/icon_tab_sg_c.png'),
                    activeUrl: require('@/assets/image/SIBI/tabbar/icon_tab_sg_o.png')
                }
            },
            {
                path: "myBond",
                name: "myBond",
                component: () => import("@/views/SIBI/bondPage/myBond.vue"),
                meta: {
                    title: '我的订单',
                }
            },
            {
                path: "bondDetails",
                name: "bondDetails",
                component: () => import("@/views/SIBI/bondPage/bondDetails.vue"),
                meta: {
                    title: '订单详情',
                }
            },
            {
                path: "promotionPage",
                name: "promotionPage",
                component: () => import("@/views/SIBI/promotionPage/index.vue"),
                meta: {
                    type: 'tabbar',
                    title: '团队',
                    url: require('@/assets/image/SIBI/tabbar/icon_tab_td_c.png'),
                    activeUrl: require('@/assets/image/SIBI/tabbar/icon_tab_td_o.png')
                }
            },
            {
                path: "miningPage",
                name: "miningPage",
                component: () => import("@/views/SIBI/miningPage/index.vue"),
                meta: {
                    type: 'tabbar',
                    title: '资金管理',
                    url: require('@/assets/image/SIBI/tabbar/icon_tab_wd_c.png'),
                    activeUrl: require('@/assets/image/SIBI/tabbar/icon_tab_wd_o.png')
                }
            },
            {
                path: "myPledge",
                name: "myPledge",
                component: () => import("@/views/SIBI/miningPage/myPledge.vue"),
                meta: {
                    title: '资金明细',
                }
            },
        ]
    },

]